module.exports = __webpack_public_path__ + "static/media/average-score.927c9e95.svg";